export default {
  paymentDetails: {
    en: 'Payment Details',
    ja: '支払方法',
    et: 'Makse andmed',
    lt: 'Payment Details',
    ch: 'Payment Details',
    ph: 'Payment Details',
  },
  addPaymentMethod: {
    en: 'Add Payment Method',
    ja: '支払方法追加する',
    et: 'Lisa maksemeetod',
    lt: 'Add Payment Method',
    ch: 'Add Payment Method',
    ph: 'Add Payment Method',
  },
  expires: {
    en: 'Expires',
    ja: '期限切れ',
    et: 'Aegub',
    lt: 'Expires',
    ch: 'Expires',
    ph: 'Expires',
  },
  default: {
    en: 'Default',
    ja: 'デフォルト',
    et: 'Vaikimis',
    lt: 'Default',
    ch: 'Default',
    ph: 'Default',
  },
  makeDefault: {
    en: 'Make Default',
    ja: 'デフォルトにする',
    et: 'Määra vaikimisi valikuks',
    lt: 'Make Default',
    ch: 'Make Default',
    ph: 'Make Default',
  },
  noPaymentMethods: {
    en: 'Add a payment method to easily make purchases or maintain subscriptions. ',
    ja: '支払い方法を追加して、簡単に購入したり、サブスクリプションを維持したりします。',
    et: 'Lisa maksemeetod, et lihtsasti osta või tellimusi hallata',
    lt: 'Add a payment method to easily make purchases or maintain subscriptions. ',
    ch: 'Add a payment method to easily make purchases or maintain subscriptions. ',
    ph: 'Add a payment method to easily make purchases or maintain subscriptions. ',
  },
  stripeNotice: {
    en: 'Your payment information is securely saved via Stripe. You can read more about how they handle your data via their website <0>stripe.com/privacy</0>.',
    ja: 'お支払い情報はStripe経由で安全に保存されます。 Stripeのウェブサイト<0>stripe.com/privacy</0>を通してあなたのデータをどのように扱うかの詳細を読めます。',
    et: 'Sinu maksete andmed on turvaliselt salvestatud Stripe abil. Stripe lehelt <0>stripe.com/privacy</0> saad rohkem teada, kuidas sinu andmeid kaitstakse.',
    lt: 'Your payment information is securely saved via Stripe. You can read more about how they handle your data via their website <0>stripe.com/privacy</0>.',
    ch: 'Your payment information is securely saved via Stripe. You can read more about how they handle your data via their website <0>stripe.com/privacy</0>.',
    ph: 'Your payment information is securely saved via Stripe. You can read more about how they handle your data via their website <0>stripe.com/privacy</0>.',
  },
  creditCardEmpty: {
    en: 'Name on Card cannot be empty',
    ja: 'カードの名前は空欄にできません',
    et: 'Nimi kaardil on kohustuslik',
    lt: 'Name on Card cannot be empty',
    ch: 'Name on Card cannot be empty',
    ph: 'Name on Card cannot be empty',
  },
  nameOnCard: {
    en: 'Name on Card',
    ja: 'カードの名前',
    et: 'Nimi kaardil',
    lt: 'Name on Card',
    ch: 'Name on Card',
    ph: 'Name on Card',
  },
  cardDetails: {
    en: 'Card Details',
    ja: 'カード詳細',
    et: 'Kaardi andmed',
    lt: 'Card Details',
    ch: 'Card Details',
    ph: 'Card Details',
  },
  useDifferentPaymentMethod: {
    en: 'Change Payment Method',
    ja: '違う支払い方法選択する',
    et: 'Muuda maksemeetodit',
    lt: 'Change Payment Method',
    ch: 'Change Payment Method',
    ph: 'Change Payment Method',
  },

  unlockPremiumRightNow: {
    en: 'Unlock Premium Today',
    ja: '今すぐプレミアムにアップグレードする',
    et: 'Lukusta lahti Premium',
    lt: 'Unlock Premium Today',
    ch: 'Unlock Premium Today',
    ph: 'Unlock Premium Today',
  },
  checkout: {
    en: 'Checkout',
    ja: 'チェックアウト',
    et: 'Kassasse',
    lt: 'Checkout',
    ch: 'Checkout',
    ph: 'Checkout',
  },

  premium: {
    en: 'Premium',
    ja: 'プレミアム',
    et: 'Premium',
    lt: 'Premium',
    ch: 'Premium',
    ph: 'Premium',
  },

  billingRate: {
    en: 'Billing Rate',
    ja: '請求レート',
    et: 'Arveldamise periood',
    lt: 'Billing Rate',
    ch: 'Billing Rate',
    ph: 'Billing Rate',
  },
  billedAnnually: {
    en: 'Billed Annually',
    ja: '毎年請求',
    et: 'Kord aastas',
    lt: 'Billed Annually',
    ch: 'Billed Annually',
    ph: 'Billed Annually',
  },
  billMonthly: {
    en: 'Billed Monthly',
    ja: '毎月請求',
    et: 'Kord kuus',
    lt: 'Billed Monthly',
    ch: 'Billed Monthly',
    ph: 'Billed Monthly',
  },
  perMonth: {
    en: 'Per Month',
    ja: '月額',
    et: 'Iga kuu eraldi',
    lt: 'Per Month',
    ch: 'Per Month',
    ph: 'Per Month',
  },
  savings: {
    en: 'Save {{percentage}}',
    ja: 'セーブ {{percentage}}',
    et: 'Salvesta {{percentage}}',
    lt: 'Save {{percentage}}',
    ch: 'Save {{percentage}}',
    ph: 'Save {{percentage}}',
  },
  planSummary: {
    en: 'Plan Summary',
    ja: 'プラン概要',
    et: 'Plaani ülevaade',
    lt: 'Plan Summary',
    ch: 'Plan Summary',
    ph: 'Plan Summary',
  },
  total: {
    en: 'Total',
    ja: '合計',
    et: 'Kokku',
    lt: 'Total',
    ch: 'Total',
    ph: 'Total',
  },
  savingsMessage: {
    en: "You're saving {{percentage}} with this plan",
    ja: 'このプランで{{percentage}}節約です',
    et: 'Selle plaaniga säästad {{percentage}}',
    lt: "You're saving {{percentage}} with this plan",
    ch: "You're saving {{percentage}} with this plan",
    ph: "You're saving {{percentage}} with this plan",
  },
  missedSavingsMessage: {
    en: 'Switch to annual billing and save {{percentage}}',
    ja: '年次請求に切り替えて{{percentage}}を節約できます',
    et: 'Vaheta kord aastas arveldusele ja säästa {{percentage}}',
    lt: 'Switch to annual billing and save {{percentage}}',
    ch: 'Switch to annual billing and save {{percentage}}',
    ph: 'Switch to annual billing and save {{percentage}}',
  },
  upgrade: {
    en: 'Upgrade',
    ja: 'アップグレードする',
    et: 'Muuda',
    lt: 'Upgrade',
    ch: 'Upgrade',
    ph: 'Upgrade',
  },

};
